module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/separator-90a139ba9196435278b43023735925ec.svg";